import type { GrossMarginRow } from "../types/commissions.types";

/** Most recent month/year first (e.g. April 2026 before March 2026). */
export function sortGrossMarginRowsRecentFirst(rows: GrossMarginRow[]): GrossMarginRow[] {
  return [...rows].sort((a, b) => {
    const yearDiff = (b.year ?? 0) - (a.year ?? 0);
    if (yearDiff !== 0) return yearDiff;
    return (b.month ?? 0) - (a.month ?? 0);
  });
}
